import { formatDate } from "@/utils";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
export const GPSLastConnectionColumns = [
  {
    prop: "id",
    label: "ID #",
    minWidth: 80,
    fixed: true
  },
  {
    label: "Cliente",
    prop: "client.Name",
    width: 315,
    sortable: true,
    fixed: true
  },

  {
    label: "Titulo",
    prop: "label",
    width: 249,
    sortable: true,
    fixed: true
  },

  {
    prop: "daysOffline",
    label: "Días sin conexión",
    align: "center",
    minWidth: 245,
    sortable: true,
    formatter: (row) => row.daysOffline + " Dias"
  },
  {
    prop: "model_name",
    label: "Modelo",
    align: "center",
    minWidth: 245,
    sortable: true
  },
  {
    prop: "clone",
    label: "Es Clon?",
    align: "center",
    minWidth: 245,
    sortable: true,
    formatter: (props) => {
      if (props.Clone) {
        return "✔️";
      }
      return "❌";
    }
  },
  // {
  //   prop: "Creation_date",
  //   label: "Activación",
  //   minWidth: 110,
  //   formatter: props => {
  //     return " 🕒 " + formatDate(props.Last_connection, "DD/MM/YYYY hh:mm");
  //   }
  // },
  {
    prop: "last_connection",
    label: "Última conexión",
    minWidth: 235,
    sortable: true,
    formatter: (props) => {
      return formatDate(props.last_connection, "DD-MM-YYYY / hh:mm:ss");
    }
  },

  {
    label: "Vendedor",
    prop: "client.SalesPersonName",
    width: 280,
    sortable: true,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "client.SalesPersonPhoto"
    }
  },
  {
    label: "Servicio al Cliente",
    prop: "client.CustomerService",
    width: 290,
    sortable: true,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "client.CustomerServiceImage"
    }
  },
  {
    prop: "client.AccountReceivable",
    label: "Cuenta por Cobrar",
    sortable: true,
    "min-width": 170,
    formatter: ImagePersonVue
    /*
    attrs: {
      imgKey: "client.CxC"
    }
    */
  }
];

export const GPSLastConnectionActions = () => [
  {
    icon: "el-icon-s-tools",
    command: "workshop_move",
    label: "Mover al Taller",
    condition: (row) => row.status === "offline"
  },
  {
    icon: "el-icon-s-check",
    command: "transferred",
    label: "Traspasar",
    condition: (row) => row.status === "offline"
  },
  {
    icon: "el-icon-sort-up",
    command: "out_of_workshop",
    label: "Sacar del taller",
    condition: (row) => row.status === "workshop"
  },
  {
    icon: "el-icon-document-checked",
    command: "retrieve",
    label: "Recuperar",
    condition: (row) => row.status === "sold"
  }
];

//Todo:
// hacer que funcionen las acciones de cambiar estatus al taller y a traspasado
// llamar metodo de los equipos en taller y traspasados para hacer logica de filtrar los gps
